import { sliceEvents, createPlugin } from '@fullcalendar/core';

const CustomViewConfig = {

  classNames: [ 'custom-view' ],
  duration: { days: 4 },

  content: function(props) {
    let segs = sliceEvents(props, true); // allDay=true
    let html =
      '<div class="view-title">' +
        props.dateProfile.currentRange.start.toUTCString() +
      '</div>' +
      '<div class="view-events">' +
        segs.length + ' events' +
      '</div>'

    return { html: html }
  }

}

export default createPlugin({
//   views: {
//     custom: CustomViewConfig
//   }
    views: {
        xxx: {
            type: 'dayGridMonth',
            // buttonText: 'ماه شمسی',
            // start: '2023-01-01',
            // end: '2023-01-31',
            initialDate: "2023-06-21",
            // validRange: {
            //         start: "2023-06-17",
            //         end: "2023-07-28",
            //     },
            visibleRange: {
                start: '2023-06-17',
                end: '2023-07-28'
            },
            // duration: { days: 4 }
            // visibleRange:{
            //     start: '2023-06-17', //روز اول ماه شمسی
            //     end: '2023-08-28' // روز آخر بیستم بود که یه روز اضاف کردم تا درست شد
            // },
            // validRange: function(currentDate) {
            //     // Generate a new date for manipulating in the next step
            //     var startDate = new Date(currentDate.valueOf());
            //     var endDate = new Date(currentDate.valueOf());
        
            //     // Adjust the start & end dates, respectively
            //     startDate.setDate(startDate.getDate() - 1); // One day in the past
            //     endDate.setDate(endDate.getDate() + 2); // Two days into the future

            //     startDate = '2023-02-21'
            //     endDate = '2023-04-21'
        
            //     // return { start: startDate, end: endDate };
            // },
        }
    }
});